import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OpenAiSettingDialogComponent } from './open-ai-setting-dialog/open-ai-setting-dialog.component';
import { ThirdPartyManager } from '../../../../managers/third-party.manager';
import { EMPTY, switchMap } from 'rxjs';
import { BaseComponent } from '../../../base.component';
import { Store } from '@ngrx/store';
import { openAiSettingsActions } from '@store/third-party/open-ai-settings/open-ai-settings.actions';

@Component({
    selector: 'lex-third-party-open-ai',
    templateUrl: './third-party-open-ai.component.html',
    styleUrls: ['./third-party-open-ai.component.scss'],
    standalone: false
})
export class ThirdPartyAppOpenAiComponent extends BaseComponent implements OnInit {

	public isLinked: boolean = false;
	public isLoading: boolean = true;

	constructor(private dialog: MatDialog, private thirdPartyManager: ThirdPartyManager, private store: Store) {
		super();
	}

	ngOnInit(): void {
		this.isLoading = true;
		this.thirdPartyManager.isOpenAiLinked().subscribe((data) => {
			this.isLinked = data;
			if (this.isLinked)
				this.store.dispatch(openAiSettingsActions.initialize());
		}, null, () => {
			this.isLoading = false;
		});
	}

	public link(): void {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.width = '500px';
		this.dialog.open(OpenAiSettingDialogComponent, dialogConfig)
			.afterClosed()
			.pipe(switchMap((needUpdate) => {
				if (needUpdate) {
					this.isLoading = true;
					return this.thirdPartyManager.isOpenAiLinked();
				}
				return EMPTY;
			}))
			.subscribe((data) => {
				this.isLinked = data;
			}, null, () => {
				this.isLoading = false;
			});
	}

}
